import {useAuth0} from '@auth0/auth0-react';
import {CssBaseline, StyledEngineProvider, ThemeProvider} from '@mui/material';
import {AdminTheme} from '@pinecone-experience/theme';
import LoadingPage from './components/LoadingPage';
import MainApp from './components/MainApp';

function App() {
  const {isAuthenticated, isLoading, loginWithRedirect} = useAuth0();

  let content;
  if (isLoading) {
    content = <LoadingPage />;
  } else if (!isAuthenticated) {
    loginWithRedirect();
    content = <LoadingPage />;
  } else {
    content = <MainApp />;
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={AdminTheme}>
        <CssBaseline />
        {content}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
